import { omit, map } from "ramda";
import { camelizeKeys } from "humps";

import { NewProductSerialized, INewProductViewModel } from "typings";
import { newProductStatusParser } from "view-model-creator";

type NewProductViewModelCreator = (products: NewProductSerialized[]) => INewProductViewModel[];

export const newProductViewModelCreator: NewProductViewModelCreator = map(product => ({
  ...(camelizeKeys(omit(["created_at", "updated_at", "status_text", "ship_ing_speed"], product)) as any),
  status: newProductStatusParser(product.status),
  priceDesc: `${product.price.toLocaleString()}원`
}));
